export default __webpack_public_path__ + "static/media/logosvk.90e700cd.svg";